<template>
  <div id="page-wrapper" class="managerdash" :data-managedusers="managedUsers" :class="popupShown ? 'popup-shown' : ''">

    <transition name="teampopupdash">
      <div id="popup-wrapper" v-if="popupShown">
        <template>
          <button class="btn btn-link text-white close" @click.prevent.stop="closePopup">
            <i class="fal fa-times"></i>
          </button>
          <h2>{{popupTeam.Title}}</h2>
          <team-review :team="popupTeam"></team-review>
        </template>
      </div>
    </transition>

    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>
        <div class="main-page-content  ml-0">
          <div id="main-wrapper" class="layout-main-wrapper clearfix">
            <div id="main" class="container-fluid">
              <div class="row row-offcanvas row-offcanvas-left clearfix">
                <main class="main-content col content-full-width" id="content" role="main">
                  <section id="overview-manager" class="section">
                    <div class="container-fluid">
                      <div class="row mb-15">
                        <div class="col-left col-md-12">

                          <nav class="tabnav tab-nav mb-0">
                            <button
                              :class="(activeTab === 0 ? 'active' : '')"
                              @click.stop.prevent="activeTab = 0"
                              class=" btn-link btn tab-link">
                              {{ $t('message.teams') }}
                            </button>
                            <button
                              v-if="accesslevel >= 90"
                              :class="(activeTab === 1 ? 'active' : '')"
                              @click.stop.prevent="activeTab = 1"
                              class=" btn-link btn tab-link">
                              {{ $t('message.tree') }}
                            </button>
                            <button
                              :class="(activeTab === 2 ? 'active' : '')"
                              @click.stop.prevent="activeTab = 2"
                              class=" btn-link btn tab-link">
                              {{ $t('message.heatmap') }}
                            </button>
                            <button
                              v-if="accesslevel >= 90"
                              :class="(activeTab === 3 ? 'active' : '')"
                              @click.stop.prevent="activeTab = 3"
                              class=" btn-link btn tab-link">
                              {{ $t('message.company') }}
                            </button>
                            <button
                              v-if="accesslevel >= 90"
                              :class="(activeTab === 4 ? 'active' : '')"
                              @click.stop.prevent="activeTab = 4"
                              class=" btn-link btn tab-link">
                              {{ $t('message.demographics') }}
                            </button>
<!--                            <button-->
<!--                              :class="(activeTab === 5 ? 'active' : '')"-->
<!--                              @click.stop.prevent="activeTab = 5"-->
<!--                              class=" btn-link btn tab-link">-->
<!--                              {{ $t('message.activity') }}-->
<!--                            </button>-->
                          </nav>

                          <div class="tab-content" v-show="activeTab === 0">
                            <div class="col-md-12">
                              <div class="row">
                                <team-card
                                  @clickedTeam="clickedTeamHandler"
                                  :vitamins="vitamins"
                                  :vitaminScores="vitaminScores"
                                  class="col-md-6"
                                  v-for="team in teams"
                                  v-bind:key="team.id"
                                  :data-id="team.id"
                                  :team="team"></team-card>
                              </div>
                            </div>
                          </div>

                          <div class="tab-content" v-show="activeTab === 1">
                            <div id="team-overview" class="col-card card-h-auto maximizable">
                              <button class="d-block btn-enlarge maximize-btn" @click.stop="maximize">
                                <i class="fas fa-expand"></i>
                              </button>
                              <button class="btn-minimize minimize-btn" @click.stop="minimize">
                                <i class="fas fa-compress"></i>
                              </button>
                              <company-tree @clickedTeam="clickedTeamHandler"
                                            ref="tree"
                                            :tree-type="'manager'">
                              </company-tree>
                            </div>
                          </div>

                          <div class="tab-content" v-show="activeTab === 2">
                            <div class="heatmap" v-if="teamsLoaded">
                              <heatmap @openTeamPopup="openTeamPopup" :teams="heatmapteams"
                                       :vitamins="vitamins"></heatmap>
                            </div>
                          </div>

                          <div class="tab-content" v-show="activeTab === 3">
                            <div class="tab-content">
                              <team-review :is-company="true"
                                           :team="company">
                              </team-review>
                            </div>
                          </div>

                          <div class="tab-content" v-show="activeTab === 4">
                            <div class="col-md-12">
                              <demographics @clickedTeam="clickedTeamHandler"
                                            class=""
                                            :vitamins="vitamins"
                                            :vitaminScores="vitaminScores">
                              </demographics>
                            </div>
                          </div>

<!--                          <div class="tab-content" v-show="activeTab === 5">-->
<!--                            <activity-log :type="'manager'"></activity-log>-->
<!--                          </div>-->

                        </div>
                      </div>
                    </div>
                  </section>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Activitylog from "../Activitylog";
  import Header from "../Header";
  import Nav from "../Nav";
  import TeamTree from "../Tree/TeamTree";
  import Filter from "../Tree/Filter"
  import store from "../../store/store";
  import moment from "moment";
  import draggable from "vuedraggable";
  import CompanyTree from "../Tree/CompanyTree";
  import AllVitamins from "../Review/AllVitamins";
  import EvolutionChart from "../Charts/EvolutionChart"
  import GenericChart from "../Charts/GenericChart"
  import TeamReview from "../Review/TeamReview";
  import TeamCard from "../Review/TeamCard"
  import Demographics from '../Review/Demographics'
  import Heatmap from "../Review/Heatmap";

  export default {
    components: {
      Heatmap,
      Demographics,
      TeamReview,
      AllVitamins,
      draggable,
      CompanyTree,
      EvolutionChart,
      GenericChart,
      appHeader: Header,
      appNavbar: Nav,
      activityLog: Activitylog,
      teamTree: TeamTree,
      filterRow: Filter,
      TeamCard
    },
    data() {
      return {
        popupShown: false,
        popupTeam: null,
        allTeams: [],
        evolutionStart: moment().subtract(3, 'days').format('YYYY-MM-DD'),
        evolutionEnd: moment().format('YYYY-MM-DD'),
        teamsLoaded: false,
        activeTeam: 0,
        teams: [],
        activeTab: 0,
        managedUsers: [],
        store,
        // companyAvg: {},
        vitamins: [],
        company: null,
        vitaminScores: {}
      }
    },
    computed: {
      heatmapteams() {
        let teams = this.teams;
        if (this.accesslevel >= 90) {
          teams = this.allTeams
        }
        return teams
      },
      teamUserIds() {
        let ids = [];
        this.teams[this.activeTeam].users.forEach(user => {
          ids.push(user.id)
        });
        return ids
      },
    },
    methods: {
      openTeamPopup(team) {
        this.popupTeam = team;
        this.popupShown = true;
      },
      clickedTeamHandler(team) {
        this.openTeamPopup(team)
      },
      closePopup() {
        this.popupShown = false;
      },
      async getVitamins() {
        const vitamins = await this.axios.get('/vitamines?published=1&_sort=sort:ASC');
     //   console.log('fetched vitamins', vitamins.data);
        this.vitamins = vitamins.data;
        this.vitamins.forEach(vitamin => {
          this.vitaminScores[vitamin.id] = vitamin
        })
      },
      async loadTeam(i, team) {
       // console.log('loadteam', [i, team]);
        this.activeTeam = i;
      },
      // getCompanyAverage() {
      //   // this.axios.get('/averages?type=company&_sort=date:DESC&_limit=1').then(tags => tags.data)
      //   //   .then(res => {
      //   //     const data = res[0];
      //   //     this.companyAvg = data;
      //   //   });
      // },
    },
    created() {
      this.getVitamins();
      let users = [];
      this.company = store.getters.getCompany;
      if (this.accesslevel >= 90) {
        this.axios.get('/teams/teamlist?status=1&_limit=-1').then(r => {
          this.allTeams = r.data
        });
      }
      let tq = '/teams/myteam';
      this.axios.get(tq).then(async (res) => {
        const teams = res.data;
        this.teams = teams;
        this.teamsLoaded = true;
        teams.forEach((team, ind) => {
          team.users.forEach(user => {
            users.push(user.id)
          })
        });
        this.managedUsers = users;
      });

      // this.getCompanyAverage();
    },
  }
</script>


<style>
  @keyframes slide-in {
    from {
      top: -200%;
    }
    to {
      top: 0;
    }
  }

  @keyframes slide-out {
    from {
      top: 0;
    }
    to {
      top: -200%;
    }
  }

  .teampopupdash-enter {

  }

  .teampopupdash-enter-active {
    animation: slide-in .5s ease-out forwards;
  }

  .teampopupdash-leave {

  }

  .teampopupdash-leave-active {
    animation: slide-out .5s ease-out forwards;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Managerdash.vue